<!--suppress HtmlUnknownTag -->
<template>
  <div class="text-center kpi-info-chart">
    <i v-if="loading" class="fa-light fa-3x fa-spinner fa-pulse fa-fw"></i>
    <canvas v-else ref="myChart" width="700" height="225"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "MetricKpiInfoChart",
  mixins: [FormatMixin],
  props: {
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: {
      type: Object,
      required: true
    },
    pKpiName: {
      type: String,
      required: true
    },
    pDataListInput: Object,
    pCalendarTimeline: String,
    pTimelinePeriodStartDateText: String
  },
  data: function () {
    return {
      loading: true,
      chartData: null
    }
  },
  methods: {
    renderChart: function () {
      let $ctx = $(this.$refs.myChart);

      let chart = $ctx.data('chart');
      if(chart)
      {
        chart.destroy();
      }
      chart = new Chart($ctx, {
        data: {
          datasets: [{
            type: 'line',
            label: this.pDictionary['dictionary.media.insertion.kpi.planned'],
            data: this.chartData.plannedMeasures,
            stepped: 'middle',
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.8)'
          },
            {
              type: 'bar',
              label: this.pDictionary['dictionary.media.insertion.kpi.actual'],
              data: this.chartData.actualMeasures,
              borderColor: 'rgb(54, 162, 235)',
              backgroundColor: 'rgba(54, 162, 235, 0.5)'
            }],
          labels: this.chartData.timelineLabels
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }
      });

      $ctx.data('chart', chart);
    },
    refreshChart: function () {
      let _component = this;
      _component.loading = true;
      _component.chartData = null;
      $.ajax({
               type: "POST",
               url: "/mediaplan/app/endpoints/json-api/metrics/kpis/" + _component.pKpiName.toUpperCase() + "/chart?" +
                    "calendarTimeline=" + _component.pCalendarTimeline +
                    "&timelinePeriodStartDateText=" + _component.pTimelinePeriodStartDateText,
               data: JSON.stringify(_component.pDataListInput),
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (data) {
        _component.chartData = data;
        _component.loading = false;
        _component.$nextTick(function () {
          _component.renderChart();
        });
      });
    }
  },
  watch: {
    pCalendarTimeline: function () {
      this.refreshChart();
    },
    pTimelinePeriodStartDateText: function () {
      this.refreshChart();
    }
  },
  mounted: function () {
    this.refreshChart();
  }
}
</script>

<style scoped>

</style>